<template>
  <div class="card">
    <div class="dataSubscriptionWripper">
      <form autocomplete="off">
        <div style="font-size: 1rem" id="profileVueApp" name="data-tbl">
          <div class="col-md-12" style="margin-top: 24px" />

          <h4 class="text-center">Personal Info</h4>
          <div class="col-md-12" style="margin-top: 24px" />

          <div class="row">
            <label for="firstName" class="col-sm-2 col-form-label">Name:</label>
            <input
              id="firstName"
              class="form-control col personalInfoInput"
              :value="fullName"
              type="text"
              readonly
            />
          </div>
          <div class="col-md-12" style="margin-top: 24px" />

          <div class="row">
            <label for="email" class="col-sm-2 col-form-label">Email:</label>
            <input
              id="email"
              class="form-control col personalInfoInput"
              :value="getUserData.email"
              type="text"
              readonly
            />
          </div>
          <div class="col-md-12" style="margin-top: 24px" />

          <div class="row">
            <label for="companyName" class="col-sm-2 col-form-label"
              >Company:</label
            >
            <input
              id="companyName"
              :value="getUserData.companyName"
              class="form-control col personalInfoInput"
              type="text"
              readonly
            />
          </div>
          <div class="col-md-12" style="margin-top: 24px" />

          <div class="form-group row">
            <label for="phone" class="col-sm-2 col-form-label">Phone:</label>
            <input
              id="phone"
              class="form-control col personalInfoInput"
              :value="getUserData.phone"
              type="text"
              readonly
            />
          </div>
          <div class="clearfix"></div>
          <div class="col-md-12" style="margin-top: 24px"></div>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.dataSubscriptionWripper {
  padding: 10px;
}

.personalInfoInput{
  margin-right: 16px;
}
</style>

<script>
import { mapGetters } from "vuex";
export default {
  name: "authors-table",
  computed: {
    ...mapGetters(["getUserData"]),
    fullName() {
      return this.getUserData.firstName + " " + this.getUserData.lastName;
    },
  },
};
</script>
